import { unflatten } from 'flat';
import React from 'react';
import PropTypes from 'prop-types';

const InfluencerCompanyStatus = ({ record }) => {
  const recordUnflatten = unflatten(record);
  const status = recordUnflatten.params.affiliateDataObject
    ? recordUnflatten.params.affiliateDataObject.status : '';
  let statusHTML = '-';
  if (status === 'deleted') {
    statusHTML = (<span className="text-danger">Deleted</span>);
  }
  if (status === 'active') {
    statusHTML = (<span className="text-success">Active</span>);
  }
  if (status === 'blocked') {
    statusHTML = (<span className="text-secondary">Blocked</span>);
  }
  return (
    <span style={{
      display: 'block',
      textAlign: 'center',
      marginRight: '1rem',
    }}
    >
      {statusHTML}
    </span>
  );
};
InfluencerCompanyStatus.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default InfluencerCompanyStatus;
